import { createI18nText } from '@hilma/netina2all';

const footerText = createI18nText({
	he: {
		alsoPurchase: 'גם אני רוצה לרכוש',
		findFB: 'חפשו אותנו ב'
	},
	en: {
		alsoPurchase: 'I also want to buy',
		findFB: 'Find us on',
	}
});

export default footerText;